import { baseApi } from "../baseApi";
import { pick } from "../util";
import type { StockLevel } from "../types";

const STOCK_LEVEL_FIELDS = `
  id
  organizationId
  productId
  warehouseId
  quantity
  createdAt
  updatedAt
`;

// Read-only — there's no createStockLevel/updateStockLevel/deleteStockLevel;
// rows are only ever written by stockAdjustmentApi.ts's adjustStock mutation.
export const stockLevelApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStockLevels: builder.query<
      StockLevel[],
      { organizationId?: string; productId?: string; warehouseId?: string } | void
    >({
      query: (args) => ({
        body: {
          query: `
            query StockLevels($organizationId: String, $productId: String, $warehouseId: String) {
              stockLevels(organizationId: $organizationId, productId: $productId, warehouseId: $warehouseId) {
                ${STOCK_LEVEL_FIELDS}
              }
            }
          `,
          variables: {
            organizationId: args?.organizationId ?? null,
            productId: args?.productId ?? null,
            warehouseId: args?.warehouseId ?? null,
          },
        },
      }),

      transformResponse: (res: unknown) => pick<StockLevel[]>(res, "stockLevels"),

      providesTags: (result) =>
        result
          ? [
              ...result.map((s) => ({ type: "StockLevel" as const, id: s.id })),
              { type: "StockLevel" as const, id: "LIST" },
            ]
          : [{ type: "StockLevel" as const, id: "LIST" }],
    }),
  }),
});

export const { useGetStockLevelsQuery, useLazyGetStockLevelsQuery } = stockLevelApi;
